// =============================
// Imports
// =============================

import { createElement, Component } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from '../../../config/i18n';

// =============================
// Component
// =============================

function getErrorProps(context, meta, helperText, errorAsTooltip) {
  const noError = {
    error: undefined,
    helperText,
  };

  if (
    !meta.error
    || (context === 'autosave' && !meta.dirty)
    || (context !== 'autosave' && !meta.touched)
  ) {
    return noError;
  }

  const errorProps = { error: true };

  if (errorAsTooltip) {
    errorProps.tooltipError = meta.error;
  } else {
    errorProps.helperText = meta.error;
  }

  return errorProps;
}

/**
 * This component is used as a passerelle between React final form and Mewo component
 */

class MewoInput extends Component {
  static propTypes = {
    /** In which saving context this input is used */
    context: PropTypes.string,
    /** helper text for input */
    helperText: PropTypes.string,
    /** Prop passed down by React final form */
    input: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    /** Props passed down by React final form */
    meta: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    /** Additional onChange, so it could be used outside of final-form */
    onChangePassthrough: PropTypes.func,
    /** Show error as a tooltip */
    errorAsTooltip: PropTypes.bool,
    /** i18n func. */
    t: PropTypes.func.isRequired,
    /** Input Component that will be used */
    use: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  static defaultProps = {
    context: '',
    helperText: '',
    onChangePassthrough: () => {},
    errorAsTooltip: false,
  };

  render() {
    const {
      input,
      meta,
      context,
      use,
      onChangePassthrough,
      errorAsTooltip,
      helperText,
      t,
      ...restProps
    } = this.props;

    return createElement(use, {
      ...input,
      onChange: (...args) => {
        onChangePassthrough(...args);
        return input.onChange(...args);
      },
      ...getErrorProps(context, meta, helperText, errorAsTooltip),
      ...restProps,
      isTranslatableMessage: t('components:mewo_input.is_translatable_message'),
    });
  }
}

export default withTranslation(['components'])(MewoInput);
